import { FetchUserDocument, FetchUserQuery } from './user.generated';
import { updateUserTaxonomyKeys } from '../updateUserTaxonomyKeys';
import { fetchGraphql } from '@zoopla/fetch-graphql';
import { logError } from '@zoopla/logger';

export type UserTaxonomy = {
    user_uuid?: string | undefined | null;
    user_id?: number | undefined | null;
    registered?: boolean | undefined | null;
    signed_in_status?: string;
    about_me_status?: string | undefined | null;
    registration_platform?: string | undefined | null;
    user_creation_date?: string | undefined | null;
};

export const getUserTaxonomy = async (): Promise<UserTaxonomy> => {
    try {
        const { data, errors } = await fetchGraphql<FetchUserQuery>(
            FetchUserDocument
        );

        if (errors) {
            logError(errors);
        }

        return updateUserTaxonomyKeys(data?.user);
    } catch (err) {
        console.error(err);
        return updateUserTaxonomyKeys({});
    }
};
